import { CartResponseLineItemType } from '../../../apis/src/cart/types';

export const toAllDiscounts = (lineItems: Array<CartResponseLineItemType>) => {
  return lineItems
    .filter(item => item.Promotions?.length)
    .map(item => ({
      sku: item.SKU,
      lineId: item.Id,
      quantity: item.Quantity,
      totalPriceInc: Math.round(item.LineTotalInc * 100),
      discounts: item.Promotions.map(promotion => ({
        id: item.Id,
        amount: Math.round(promotion.DiscountInc * 100),
        type: promotion.PromotionType,
        title: promotion.Name,
        reference: promotion.Reference,
        name: promotion.CouponName,
      })),
    }));
};
